import { Action, ActionReducer } from '@ngrx/store';
import { DalState } from '../dal.state.interface';
import { UserActionTypes } from '../user/user.actions';
import { MetaReducerActionTypes } from './meta-reducer.actions';

export function clearState(rootReducer: ActionReducer<any>): ActionReducer<any> {
  return function (state: DalState, action: Action) {
    const allowedActions: string[] = [UserActionTypes.UserRemoved, MetaReducerActionTypes.ClearState];

    if (allowedActions.includes(action.type)) {
      // return an undefined state
      // therefore all of the reducers will return the initial value as they are supposed to
      state = undefined;
    }

    return rootReducer(state, action);
  };
}
